import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ConfigPedidoModule } from '../../../../configuracoes/app/pedido';
import { PedidoNaoLiberadoPipeModule } from '../../../../pedido/nao-liberado/pipes';
import { ClientePipeSharedModule } from '../../../../pessoa/cliente/pipes';
import { RepresentantePipeSharedModule } from '../../../../pessoa/representante/pipes';

import { CampanhaPedidoNaoLiberadoPipelineCardComponent } from './campanha-pedido-nao-liberado-pipeline-card.component';

@NgModule({
    imports: [
        SharedModule,
        ConfigPedidoModule,
        PedidoNaoLiberadoPipeModule,
        ClientePipeSharedModule,
        RepresentantePipeSharedModule
    ],
    declarations: [
        CampanhaPedidoNaoLiberadoPipelineCardComponent
    ],
    exports: [
        CampanhaPedidoNaoLiberadoPipelineCardComponent
    ]
})
export class CampanhaPedidoNaoLiberadoPipelineCardModule { }
